import { motion } from 'framer-motion';
import { useHistory } from 'react-router';
import { css } from 'styled-components';

import { LAST_ANIMATION_DELAY } from 'src/app/components/FeatureLayouts/SimpleFeatureLayout/constants';
import {
  SimpleFeatureLayout,
  SimpleFeatureLayoutPageContainer,
} from 'src/app/components/FeatureLayouts/SimpleFeatureLayout/SimpleFeatureLayout';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import { showYourDoctor } from 'src/app/router/paths';

const mixBlendNormalShadow = css`
  mix-blend-mode: normal;
  opacity: 0.15;
`;

const StethoscopeArt = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 375 283">
    <circle cx="188" cy="141" r="105" fill="#99BFBC" />
    <motion.g
      id="tellyourdoctor-stethoscope"
      animate={{ x: -40, y: 22, opacity: 1, rotate: '15deg' }}
      initial={{ x: -40, y: 30, opacity: 0, rotate: '15deg' }}
      transition={{
        ease: 'easeIn',
        duration: 0.3,
        delay: LAST_ANIMATION_DELAY,
      }}
    >
      <path
        fill="#597F7C"
        fillRule="evenodd"
        d="M188.13 84.25c3.87 0 7.03-3.1 7.12-6.95 6.65-1.26 11.67-.4 15.04 2.6 9.67 8.6 6.02 33.08 3 52.83a54.2 54.2 0 0 1-.45 3.47 3.31 3.31 0 0 0-1.9 2.76c-1.94 23.4-6.66 35.86-14.18 37.8-7.51 1.93-17.82-6.23-31.35-25.56a3.5 3.5 0 0 0-3.43-1.4 61.65 61.65 0 0 1-2.15-2.68c-12.45-15.46-27.92-35-23.84-47.24 1.35-4.4 5.42-7.79 12.08-10a7.12 7.12 0 1 0-1.05-3.17c-7.66 2.5-12.51 6.7-14.25 12.1-4.46 13.8 11.26 33.7 24.07 49.93l.41.53c.8.9 1.53 1.75 2.24 2.6a3.34 3.34 0 0 0 .34 3.2c8.47 12.05 18.93 25.09 29.92 28.12l8.1 9.64a26.97 26.97 0 0 0 6.56 8.81c-11.38 2.58-21.26 8.38-27.91 16.54-8.16 10.3-10.74 24.26-6.45 35.64 4.3 11.6 15.68 19.54 27.27 19.54h3.23c8.37-1.07 16.53-6.44 22.11-14.6 10.53-15.46 9.67-36.93-1.72-51.53a97.73 97.73 0 0 1 20.83 3.86c4.51 1.29 9.02 3 13.32 4.73 1.52.52 3.06 1.08 4.61 1.65 4.15 1.5 8.4 3.05 12.78 4.14l1.37.35c8.77 2.2 19.33 4.86 28.96 2.4a13.96 13.96 0 1 0-2.67-6.4c-8.25 1.7-17.88-.8-25.94-3-5.58-1.5-11.17-3.65-16.75-5.8-4.51-1.72-9.02-3.44-13.74-4.94-10.74-3.22-20.83-4.72-30.06-4.08l-.22-.21-.5-.38-.02-.01c-3.05-2.29-6.14-4.6-8.4-8.6l1.36-11.96c2.73-2.75 4.99-6.65 6.78-11.68 2.37-6.87 3.87-15.67 4.94-27.7a3.17 3.17 0 0 0-1.31-3.03l.03-.19c.16-1.07.32-2.14.42-3.22 3.23-20.4 6.88-45.95-4.08-55.83-4.36-3.6-10.4-4.86-18.12-3.33a7.12 7.12 0 1 0-6.4 10.25Zm23.8 122.98c-.43 0-.86.05-1.3.1-.42.06-.85.11-1.28.11-11.38 1.72-21.26 7.09-27.48 14.82-6.88 8.37-9.02 19.97-5.37 29.2 3.65 9.66 13.95 16.1 23.4 15.03 6.66-.86 12.89-5.15 17.4-11.8 9.23-13.32 7.94-33.08-3.01-45.1-.42-.56-.94-1.04-1.49-1.54-.28-.26-.58-.53-.87-.82Z"
        clipRule="evenodd"
        css={mixBlendNormalShadow}
      />
      <path fill="#EF4931" d="M184.03 177.34 193 188l2.63-1 3.87-1 1.5-13.17-16.97 4.5Z" />
      <path
        fill="#fff"
        d="M156.33 149.2a82.93 82.93 0 0 0-4.08-4.93c-12.88-16.32-28.98-36.5-24.48-50.46 1.94-6.02 7.73-10.53 16.97-12.89l.86 3.22c-8.16 2.15-13.1 5.8-14.6 10.74-4.08 12.24 11.38 31.78 23.83 47.24 1.29 1.72 2.8 3.44 4.08 4.94l-2.58 2.15ZM210.88 134.6l-3.44-.43c.21-2.14.64-4.07.86-6.44 3-19.75 6.66-44.23-3-52.82-3.87-3.44-9.89-4.08-18.05-1.93l-.85-3.22c9.23-2.58 16.31-1.5 21.25 2.57 10.95 9.88 7.3 35.43 4.08 55.83-.21 2.15-.64 4.3-.85 6.44Z"
      />
      <circle cx="149.13" cy="81.13" r="7.13" fill="#0F3C6C" />
      <circle cx="183.13" cy="72.13" r="7.13" fill="#0F3C6C" />
      <path
        fill="#EF4931"
        d="M189.4 178.84c-12.67 0-24.9-15.03-34.57-28.78a3.43 3.43 0 0 1 .86-4.72 3.43 3.43 0 0 1 4.72.86c13.53 19.33 23.84 27.49 31.35 25.55 7.52-1.93 12.24-14.38 14.18-37.79.21-1.93 1.71-3.22 3.65-3 1.93.2 3.22 1.71 3 3.64-1.07 12.03-2.57 20.83-4.94 27.7-3.22 9.02-7.94 14.4-14.17 16.1-1.5.22-2.79.44-4.08.44Z"
      />
      <path
        fill="#EF4931"
        d="M192.32 268.36c-11.59 0-22.97-7.94-27.27-19.54-4.29-11.38-1.71-25.33 6.45-35.64 6.65-8.16 16.53-13.96 27.91-16.54-4.3-3.86-8.16-9.44-9.66-19.75-.22-1.93 1.07-3.65 2.79-3.87 1.93-.21 3.65 1.08 3.87 2.8 1.5 11.59 6.87 15.24 12.02 19.1l.22.22c9.23-.64 19.32.86 30.06 4.08 4.72 1.5 9.23 3.22 13.74 4.94 5.58 2.15 11.17 4.3 16.75 5.8 9.45 2.57 21.04 5.58 30.06 1.72 1.72-.65 3.65 0 4.51 1.71.65 1.72 0 3.65-1.72 4.51-11.16 4.94-24.26 1.3-34.57-1.29-6.01-1.5-11.8-3.86-17.4-5.8-4.29-1.71-8.8-3.43-13.3-4.72a97.73 97.73 0 0 0-20.83-3.86c11.38 14.6 12.24 36.07 1.71 51.53-5.58 8.16-13.74 13.53-22.11 14.6h-3.23Zm14.6-66.13c-.85 0-1.71.21-2.57.21-11.38 1.72-21.26 7.09-27.48 14.82-6.88 8.37-9.02 19.97-5.37 29.2 3.65 9.66 13.95 16.1 23.4 15.03 6.66-.86 12.89-5.15 17.4-11.8 9.23-13.32 7.94-33.08-3.01-45.1-.64-.86-1.5-1.5-2.36-2.36Z"
      />
      <path fill="#0F3C6C" d="M308.96 224.91a13.96 13.96 0 1 0 0-27.91 13.96 13.96 0 0 0 0 27.91Z" />
    </motion.g>
    <motion.g
      id="tellyourdoctor-chat-bubble-1"
      animate={{ y: 0, opacity: 1 }}
      initial={{ y: 16, opacity: 0 }}
      transition={{
        ease: 'easeIn',
        duration: 0.3,
        delay: LAST_ANIMATION_DELAY,
      }}
    >
      {/* Chat box 1 - Doctor: "What's your pharmacy" */}
      {/* Shadow */}
      <svg xmlns="http://www.w3.org/2000/svg" width="140" height="75" x="206" y="42.3" viewBox="0 0 140 75" fill="none">
        <path
          d="M8.80535 49.8115V60.8406C8.80535 65.5514 6.70115 70.0159 3.06776 73.0141L2.59599 73.4034C2.02658 73.8733 2.35652 74.798 3.09475 74.8012L38.6356 74.9594L18.2752 60.5868L8.80535 49.8115Z"
          fill="#597F7C"
          css={mixBlendNormalShadow}
        />
        <path
          d="M8.77197 12.0395C8.77197 5.5556 14.0283 0.299316 20.5122 0.299316H127.486C133.97 0.299316 139.227 5.5556 139.227 12.0395V63.2168C139.227 69.7008 133.97 74.9571 127.486 74.9571H35.0771C20.5492 74.9571 8.77197 63.1799 8.77197 48.652V12.0395Z"
          fill="#597F7C"
          css={mixBlendNormalShadow}
        />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="139" height="75" x="203" y="40" viewBox="0 0 139 75" fill="none">
        {/* Chat box */}
        <path
          d="M7.89153 49.5122V60.5413C7.89153 65.2521 5.78733 69.7166 2.15394 72.7148L1.68217 73.1041C1.11276 73.574 1.4427 74.4986 2.18093 74.5019L37.7218 74.6601L17.3614 60.2875L7.89153 49.5122Z"
          fill="#F6F7F8"
        />
        <path
          d="M7.85864 11.7402C7.85864 5.25628 13.1149 0 19.5989 0H126.573C133.057 0 138.313 5.25628 138.313 11.7402V62.9175C138.313 69.4015 133.057 74.6577 126.573 74.6577H34.1637C19.6358 74.6577 7.85864 62.8805 7.85864 48.3526V11.7402Z"
          fill="#F6F7F8"
        />
        <text
          width="97.8352"
          height="44.6129"
          rx="22.3064"
          y="32.97"
          x="24.74"
          font-family="Circular-Pro, Helvetica, Arial, sans-serif"
          font-size="17.78px"
          font-style="normal"
          font-weight="450"
          line-height="21.371px"
          fill="#0F3C6C"
        >
          What's your
        </text>
        <text
          width="97.8352"
          height="44.6129"
          rx="22.3064"
          y="55.19"
          x="24.74"
          font-family="Circular-Pro, Helvetica, Arial, sans-serif"
          font-size="17.78px"
          font-style="normal"
          font-weight="450"
          line-height="21.371px"
          fill="#0F3C6C"
        >
          pharmacy?
        </text>
      </svg>
    </motion.g>
    <motion.g
      id="tellyourdoctor-chat-bubble-2"
      animate={{ y: 0, opacity: 1 }}
      initial={{ y: '5%', opacity: 0 }}
      transition={{
        ease: 'easeIn',
        duration: 0.3,
        delay: LAST_ANIMATION_DELAY + 1,
      }}
    >
      {/* Chat box 2 - User's response: "Capsule" */}
      {/* Shadow */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="106"
        height="46"
        x="215"
        y="127.1"
        viewBox="0 0 106 46"
        fill="none"
      >
        <path
          d="M97.8255 22.0474L98.0345 32.2435C98.1179 36.3105 99.7941 40.1824 102.703 43.0263L103.899 44.1965C104.397 44.6829 104.052 45.5278 103.357 45.5278H68.0836L87.3175 30.725L97.8255 22.0474Z"
          fill="#597F7C"
          css={mixBlendNormalShadow}
        />
        <rect
          width="97.8352"
          height="44.6129"
          rx="22.3064"
          transform="matrix(-1 0 0 1 97.8257 0.914551)"
          fill="#597F7C"
          css={mixBlendNormalShadow}
        />
      </svg>
      {/* Chat box */}
      <svg xmlns="http://www.w3.org/2000/svg" width="106" height="46" x="211" y="126" viewBox="0 0 106 46" fill="none">
        <path
          d="M97.9122 21.748L98.1212 31.9442C98.2045 36.0112 99.8807 39.8831 102.789 42.727L103.986 43.8972C104.484 44.3836 104.139 45.2285 103.443 45.2285H68.1703L87.4042 30.4257L97.9122 21.748Z"
          fill="#0F3C6C"
        />
        <rect
          x="0"
          y="0"
          width="97.8352"
          height="44.6129"
          rx="22.3064"
          transform="matrix(-1 0 0 1 97.9124 0.615723)"
          fill="#0F3C6C"
        />
        <text
          width="97.8352"
          height="44.6129"
          rx="22.3064"
          y="29"
          x="16.44"
          font-family="Circular-Pro, Helvetica, Arial, sans-serif"
          font-size="17.78px"
          font-weight="450"
          fill="white"
        >
          Capsule
        </text>
      </svg>
    </motion.g>
  </svg>
);

export const EducationalTellYourDoctor = () => {
  useSegmentEvent('viewPostOrderJustSayCapsule', { shouldTrackOnMount: true });
  const history = useHistory();

  const trackNegativeCTAClick = useSegmentEvent('selectMCYPMoreDetails', { shouldTrackOnMount: false });

  return (
    <SimpleFeatureLayoutPageContainer key="tell-your-doctor-interstitial">
      <SimpleFeatureLayout
        keyName={'tell-your-doctor-interstitial'}
        title={'Just tell your doctor your pharmacy is Capsule'}
        description={'Capsule is now your pharmacy for all your meds.'}
        backButton={{ isRendered: false }}
        closeButtonClickHandler={() => {
          history.goBack();
        }}
        cta1={{
          children: 'Got it',
          onClick: () => {
            history.goBack();
          },
        }}
        cta2={{
          children: 'More details',
          variant: 'text-md',
          onClick: () => {
            trackNegativeCTAClick();
            history.push(showYourDoctor.route);
          },
        }}
        body={{
          content: (
            <StethoscopeArt
              css={css`
                width: 375px;
                height: 283px;
              `}
            />
          ),
          type: 'artwork',
        }}
      />
    </SimpleFeatureLayoutPageContainer>
  );
};
